module.exports = __webpack_public_path__ + "5f6dcd6c539a1619c7aa9b53fe51c6bb.fbx";